export default {
  templates: []
}
